import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PathLocationStrategy, LocationStrategy } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { AppConfigState } from './store/app-config/app-config.state';
import { TranslateModule } from '@ngx-translate/core';
import { AppComponent } from './app.component';

import { StockBinDetailsComponent } from './views/stock-bin-details/stock-bin-details.component';
import { SupplyMaterialsComponent } from './views/supply-materials/supply-materials.component';
import { FactoryIssueComponent } from './views/factory-issue/factory-issue.component';
import { AddUserComponent } from './views/add-user/add-user.component';
import { LoginComponent } from './views/login/login.component';
import { ForgotPassComponent } from './views/forgot-pass/forgot-pass.component';
import { UserProfileComponent } from './views/user-profile/user-profile.component';

import { AddClientComponent } from './views/add-client/add-client.component';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TokenInterceptor } from './token.interceptor';
import { AuthenticationService } from './shared/services/authentication.service';
import { CustomerListComponent } from './views/customer-list/customer-list.component';

import { ReportsComponent } from './views/reports/reports.component';
import { OrderListComponent } from './views/order-list/order-list.component';
import { UserListComponent } from './views/user-list/user-list.component';
import { PlaceOrderComponent } from './views/place-order/place-order.component';

import { RepeatedOrderListComponent } from './views/repeated-order-list/repeated-order-list.component';
import { JssListComponent } from './views/jss-list/jss-list.component';
import { UnsavedOrderComponent } from './views/unsaved-order/unsaved-order.component';
import { PrintTicketComponent } from './views/print-ticket/print-ticket.component';
import { MatrialMixComponent } from './views/matrial-mix/matrial-mix.component';
import { OrderManagerComponent } from './views/order-manager/order-manager.component';
import { JssCreationComponent } from './views/jss-creation/jss-creation.component';
import { ProductionFormComponent } from './views/production-form/production-form.component';
import { AddMaterialComponent } from './views/add-material/add-material.component';
import { InventoryListComponent } from './views/inventory-list/inventory-list.component';
import { AddProdComponent } from './views/add-prod/add-prod.component';
import { AddInkComponent } from './views/add-ink/add-ink.component';
import { InventoryListiiComponent } from './views/inventory-listii/inventory-listii.component';
import { InventoryListiiiComponent } from './views/inventory-listiii/inventory-listiii.component';

import { ConfrmListComponent } from './views/confrm-list/confrm-list.component';

import { ProcessComponent } from './views/process/process.component';
import { MaterialListComponent } from './views/material-list/material-list.component';
import { PopupInComponent } from './views/popup-in/popup-in.component';
import { SupplyformComponent } from './views/supplyform/supplyform.component';
import { DispatchFromComponent } from './views/dispatch/dispatch-from/dispatch-from.component';
import { DispatchTableComponent } from './views/dispatch/dispatch-table/dispatch-table.component';
import { RemainDispatchTableComponent } from './views/dispatch/remain-dispatch-table/remain-dispatch-table.component';
import { ParentsOrderComponent } from './views/parents-order/parents-order.component';
import { ProdTableComponent } from './views/prod-table/prod-table.component';
import { ProdFormComponent } from './views/prod-form/prod-form.component';
import { ProdRecComponent } from './views/prod-rec/prod-rec.component';
import { ProductionInfoComponent } from './views/production/production-info/production-info.component';
import { LabelPrintComponent } from './views/product/label-print/label-print.component';
import { LabelPrintListComponent } from './views/product/label-print-list/label-print-list.component';
import { GroupWayBillComponent } from './views/dispatch/group-way-bill/group-way-bill.component';

import { NgSelectModule } from '@ng-select/ng-select';
import { PrintingProductionComponent } from './views/printing-production/printing-production.component';
import { LaminationProductionComponent } from './views/lamination-production/lamination-production.component';
import { LamprodTableComponent } from './views/lamprod-table/lamprod-table.component';
import { LamProdComponent } from './views/lam-prod/lam-prod.component';
import { PrintProdComponent } from './views/print-prod/print-prod.component';
import { PrintingTestComponent } from './views/productionForms/printing-test/printing-test.component';
import { LaminationTestComponent } from './views/productionForms/lamination-test/lamination-test.component';
import { SlittingTestComponent } from './views/productionForms/slitting-test/slitting-test.component';
import { PrintingTestTableComponent } from './views/productionForms/printing-test-table/printing-test-table.component';
import { SlittingTestTableComponent } from './views/productionForms/slitting-test-table/slitting-test-table.component';
import { LaminationTestTableComponent } from './views/productionForms/lamination-test-table/lamination-test-table.component';
import { GlueingTestComponent } from './views/productionForms/glueing-test/glueing-test.component';
import { GlueingTestTableComponent } from './views/productionForms/glueing-test-table/glueing-test-table.component';
import { ExtrusionTestComponent } from './views/productionForms/extrusion-test/extrusion-test.component';
import { ExtrusionTestTableComponent } from './views/productionForms/extrusion-test-table/extrusion-test-table.component';
import { RemaTestComponent } from './views/productionForms/rema-test/rema-test.component';
import { RemaTestTableComponent } from './views/productionForms/rema-test-table/rema-test-table.component';
import { PrintingWeekResComponent } from './views/dprReports/printing-week-res/printing-week-res.component';

@NgModule({
    declarations: [
        AppComponent,
        StockBinDetailsComponent,
        SupplyMaterialsComponent,
        FactoryIssueComponent,
        AddUserComponent,
        LoginComponent,
        ForgotPassComponent,
        UserProfileComponent,
        AddClientComponent,

        CustomerListComponent,
        ReportsComponent,
        OrderListComponent,
        UserListComponent,
        PlaceOrderComponent,
  
        RepeatedOrderListComponent,

        JssListComponent,
        UnsavedOrderComponent,
        PrintTicketComponent,
        MatrialMixComponent,
        OrderManagerComponent,
        JssCreationComponent,
        ProductionFormComponent,
        AddMaterialComponent,
        InventoryListComponent,
        AddProdComponent,
        AddInkComponent,
        InventoryListiiComponent,
        InventoryListiiiComponent,
      
        ConfrmListComponent,
   
        ProcessComponent,
        MaterialListComponent,
        PopupInComponent,
        SupplyformComponent,
        DispatchFromComponent,
        DispatchTableComponent,
        RemainDispatchTableComponent,
        ParentsOrderComponent,
        ProdTableComponent,
        ProdFormComponent,
        ProdRecComponent,
        ProductionInfoComponent,
        LabelPrintComponent,
        LabelPrintListComponent,
        GroupWayBillComponent,
        PrintingProductionComponent,
        LaminationProductionComponent,
        LamprodTableComponent,
        LamProdComponent,
        PrintProdComponent,
        PrintingTestComponent,
        LaminationTestComponent,
        SlittingTestComponent,
        PrintingTestTableComponent,
        SlittingTestTableComponent,
        LaminationTestTableComponent,
        GlueingTestComponent,
        GlueingTestTableComponent,
        ExtrusionTestComponent,
        ExtrusionTestTableComponent,
        RemaTestComponent,
        RemaTestTableComponent,
        PrintingWeekResComponent,
     
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,      NgSelectModule
,
        HttpClientModule,
        TranslateModule.forRoot(),
        LayoutModule,
        NgxsModule.forRoot([
            AppConfigState
        ]),
        NgxsReduxDevtoolsPluginModule.forRoot(),
        NgxsLoggerPluginModule.forRoot()
    ],
    providers: [AuthenticationService,
        {
            provide: HTTP_INTERCEPTORS, 
            useClass: TokenInterceptor,
            multi: true
        }

    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
